export default "__VITE_ASSET__671842d2__"